const cases = {
  И: 0,
  Р: 1,
  Д: 2,
  В: 3,
  Т: 4,
  П: 5,
} as const

const firstNameEndings: Record<string, string[]> = {
  ей: ['ей', 'ея', 'ею', 'ея', 'еем', 'ее'],
  ий: ['ий', 'ия', 'ию', 'ия', 'ием', 'ии'],
  ый: ['ый', 'ого', 'ому', 'ого', 'ым', 'ом'],
  ой: ['ой', 'ого', 'ому', 'ого', 'ым', 'ом'],
  а: ['а', 'ы', 'е', 'у', 'ой', 'е'],
  я: ['я', 'и', 'е', 'ю', 'ей', 'е'],
  ь: ['ь', 'я', 'ю', 'я', 'ем', 'е'],
  е: ['е', 'я', 'ю', 'я', 'ем', 'е'],
  о: ['о', 'а', 'у', 'о', 'ом', 'е'],
}

const lastNameEndings: Record<string, string[]> = {
  ов: ['ов', 'ова', 'ову', 'ова', 'овым', 'ове'],
  ев: ['ев', 'ева', 'еву', 'ева', 'евым', 'еве'],
  ин: ['ин', 'ина', 'ину', 'ина', 'иным', 'ине'],
  ский: ['ский', 'ского', 'скому', 'ского', 'ским', 'ском'],
  ая: ['ая', 'ой', 'ой', 'ую', 'ой', 'ой'],
  яя: ['яя', 'ей', 'ей', 'юю', 'ей', 'ей'],
}

const middleNameEndings: Record<string, string[]> = {
  ович: ['ович', 'овича', 'овичу', 'овича', 'овичем', 'овиче'],
  евич: ['евич', 'евича', 'евичу', 'евича', 'евичем', 'евиче'],
  овна: ['овна', 'овны', 'овне', 'овну', 'овной', 'овне'],
  евна: ['евна', 'евны', 'евне', 'евну', 'евной', 'евне'],
}

function declinePart(part: string, dict: Record<string, string[]>, caseIndex: number): string {
  for (const [ending, forms] of Object.entries(dict)) {
    if (part.endsWith(ending)) {
      return part.slice(0, -ending.length) + forms[caseIndex]
    }
  }
  return part
}

export function declineLastName(lastName: string, caseKey: keyof typeof cases): string {
  if (!lastName)
    return lastName

  const caseIndex = cases[caseKey]

  return declinePart(lastName, lastNameEndings, caseIndex)
}

export function declineName(name: string, caseKey: keyof typeof cases): string {
  if (!name)
    return name

  const caseIndex = cases[caseKey]

  return declinePart(name, firstNameEndings, caseIndex)
}

export function declineMiddleName(middleName: string, caseKey: keyof typeof cases): string {
  if (!middleName)
    return middleName

  const caseIndex = cases[caseKey]

  return declinePart(middleName, middleNameEndings, caseIndex)
}
